/**
 * @typedef {Object} AuthService
 * @property {function(): boolean} isLoggedIn
 * @property {function(): any} getUser
 * @property {function(any): void} login
 * @property {function(): void} logout
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @param {angular.IQService} $q
 * @returns {AuthService}
 */
function bahabotAuthFactory($resource, $q) {
    let user = null;

    const Session = $resource('/api/public/session', {}, {
        get:    { method: 'GET' },
        create: { method: 'POST' },
        destroy:{ method: 'DELETE' }
    });

    function handleSessionResponse(response) {
        if (response && (response.code === 'logged_in' || response.code === 'ok') && response.data) {
            user = response.data;
            return user;
        } else {
            user = null;
            return $q.reject('Invalid session response');
        }
    }

    return {
        isLoggedIn: function() {
            return !!user;
        },
        getUser: function() {
            return user;
        },
        login: function(credentials) {
            return Session.create(credentials).$promise
                .then(handleSessionResponse);
        },
        check: function() {
            return Session.get().$promise
                .then(handleSessionResponse)
                .catch(() => {
                    user = null;
                    return null;
                });
        },
        logout: function() {
            return Session.destroy().$promise.then(() => {
                user = null;
            });
        }
    };
}

mod.factory('AuthService', ["$resource", bahabotAuthFactory]);
